module.exports = __webpack_public_path__ + "static/media/Portrait-10213.022de616.jpg";